var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("inputActivator",function(){return [_c('v-switch',{staticClass:"themeSelector",attrs:{"title":"Theme","inset":"","flat":"","ripple":false,"hide-details":true},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})]},{"changeTheme":_vm.changeTheme,"theme":_vm.theme})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }